<!-- =========================================================================================
    File Name: ListRetailers.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<list-subscriptions filterCourses="false" :courseId="this.$route.params.courseId"></list-subscriptions>
</template>

<script>

import ListSubscriptions from '@/views/management/subscriptions/subscription-list/ListSubscriptions.vue'

export default {
  components: {
    ListSubscriptions
  }
}

</script>

<style lang="scss">
#page-product-list {
  .product-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
